(() => {
  const paper = (window.DirtPaper ||= {});
  if (paper.consentInitialized) return;
  paper.consentInitialized = true;

  const root = document.querySelector('[data-dirt-consent]');
  if (!root) return;
  const keys = ['analytics', 'marketing', 'preferences'];
  const error = root.querySelector('[data-consent-error]');
  const prefs = root.querySelector('#dirt-consent-prefs');
  const prefsToggle = root.querySelector('[data-consent-choice="prefs"]');
  const html = document.documentElement;
  const remember = () => {
    try {
      localStorage.setItem('dirt_consent_decided', '1');
    } catch (e) {}
  };

  // De keuzes achter de knoppen. "Alleen statistieken" zet alleen analytics (en
  // functionele voorkeuren) aan; "Nope, ik skip." zet alles uit.
  const presets = {
    all: { analytics: true, marketing: true, preferences: true },
    analytics: { analytics: true, marketing: false, preferences: true },
    none: { analytics: false, marketing: false, preferences: false },
  };

  function api() {
    return window.Shopify && window.Shopify.customerPrivacy;
  }

  function show() {
    root.hidden = false;
    html.classList.add('dirt-consent-active');
  }
  function hide() {
    root.hidden = true;
    html.classList.remove('dirt-consent-active');
  }

  // setTrackingConsent faalt op deze winkel ("consentManagement undefined"); de
  // keuze loopt daarom via Shopify's eigen voorkeuren-venster (verborgen met CSS):
  // openen, de drie vinkjes zetten en opslaan. Zelfde bewezen route als het
  // cookieherstel (dirt-paper-consent-recovery.js).
  function write(choice, done) {
    let settled = false;
    let applied = false;
    const finish = (ok) => {
      if (settled) return;
      settled = true;
      observer.disconnect();
      clearTimeout(timer);
      document.removeEventListener('visitorConsentCollected', onCollected);
      done(ok);
    };
    // Shopify bevestigt een vastgelegde keuze met visitorConsentCollected; dat is
    // het echte succes-signaal (betrouwbaarder dan een timer).
    const onCollected = () => finish(true);
    const applyWhenReady = () => {
      if (applied) return true;
      const inputs = keys.map((key) => document.getElementById(`shopify-pc__prefs__${key}-input`));
      const save = document.getElementById('shopify-pc__prefs__header-save');
      if (inputs.some((input) => !input) || !save) return false;
      applied = true;
      observer.disconnect();
      inputs.forEach((input, index) => {
        input.checked = !!choice[keys[index]];
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
      save.click();
      return true;
    };
    document.addEventListener('visitorConsentCollected', onCollected);
    const observer = new MutationObserver(() => applyWhenReady());
    observer.observe(document.body, { childList: true, subtree: true });
    // Als de keuze binnen 3 s niet bevestigd is, blijft de balk staan met een melding.
    const timer = setTimeout(() => finish(false), 3000);
    try {
      const banner = window.privacyBanner;
      if (banner && typeof banner.showPreferences === 'function') {
        Promise.resolve(banner.showPreferences()).catch(() => {});
      }
    } catch (e) {}
    applyWhenReady();
  }

  function apply(choice) {
    error.hidden = true;
    const buttons = root.querySelectorAll('button');
    buttons.forEach((b) => (b.disabled = true));
    write(choice, (ok) => {
      buttons.forEach((b) => (b.disabled = false));
      if (ok) {
        remember();
        document.dispatchEvent(new CustomEvent('dirt:consent', { detail: choice }));
        hide();
      } else {
        error.hidden = false;
      }
    });
  }

  function currentChoice() {
    const p = api();
    let current = {};
    try {
      current = (p && p.currentVisitorConsent && p.currentVisitorConsent()) || {};
    } catch (e) {}
    const choice = {};
    keys.forEach((key) => {
      const input = prefs.querySelector(`[data-consent-key="${key}"]`);
      choice[key] = input ? input.checked : current[key] === 'yes';
    });
    return choice;
  }

  root.addEventListener('click', (event) => {
    const button = event.target.closest('[data-consent-choice]');
    if (!button) return;
    const kind = button.getAttribute('data-consent-choice');
    if (kind === 'prefs') {
      const open = prefs.hidden;
      prefs.hidden = !open;
      prefsToggle.setAttribute('aria-expanded', String(open));
      if (open) {
        const p = api();
        let current = {};
        try {
          current = (p && p.currentVisitorConsent && p.currentVisitorConsent()) || {};
        } catch (e) {}
        keys.forEach((key) => {
          const input = prefs.querySelector(`[data-consent-key="${key}"]`);
          if (input) input.checked = current[key] === 'yes';
        });
      }
      return;
    }
    if (kind === 'save') return apply(currentChoice());
    if (presets[kind]) return apply(presets[kind]);
  });

  // De footerknop "Cookievoorkeuren" opent deze balk met de voorkeuren open.
  document.addEventListener('click', (event) => {
    if (!event.target.closest('[data-dirt-consent-reopen]')) return;
    event.preventDefault();
    show();
    if (prefs.hidden) prefsToggle.click();
    root.focus && root.focus({ preventScroll: true });
  });

  // Toon de balk alleen als Shopify een keuze verwacht én er nog geen keuze is.
  // shouldShowBanner() kijkt alleen naar de regio en blijft na een keuze true (30 okt 2026).
  // De API laadt asynchroon uit content_for_header: tot 15 seconden blijven kijken.
  const decided = (p) => {
    try {
      const current = p.currentVisitorConsent() || {};
      return keys.some((key) => current[key] === 'yes' || current[key] === 'no');
    } catch (e) {
      return false;
    }
  };
  let tries = 0;
  const timer = setInterval(() => {
    const p = api();
    if (p && typeof p.shouldShowBanner === 'function') {
      clearInterval(timer);
      try {
        if (decided(p)) remember();
        if (p.shouldShowBanner() && !decided(p)) show();
        else if (prefs.hidden) hide();
      } catch (e) {}
    } else if (++tries > 50) {
      clearInterval(timer);
      if (prefs.hidden) hide();
    }
  }, 300);
})();
